import { orderLineCoSubFromPayload } from '../../../integrations/profitPlus2k8/orderFormEdit';
import type { Order } from '../../../models/order';
import { normalizeDiscountPercent } from './orderFormTotals';
import type { OrderFormSelectedLine } from './types';

/** Map persisted order lines into form state (Profit fields are optional metadata). */
export function mapOrderLinesToSelectedProducts(o: Order): OrderFormSelectedLine[] {
  const headerWh = String(o.warehouseId || '').trim() || undefined;
  const countByProduct = new Map<string, number>();
  for (const p of o.products || []) {
    const pid = String(p.productId || '').trim();
    if (!pid) continue;
    countByProduct.set(pid, (countByProduct.get(pid) || 0) + 1);
  }
  return (o.products || []).map((p, index) => {
    const productId = String(p.productId || '').trim();
    const lineId =
      (countByProduct.get(productId) || 0) > 1
        ? `${productId}__${index}`
        : productId;
    const lineWh = String(p.warehouseId || '').trim() || undefined;
    return {
      id: lineId,
      productId,
      code: p.code,
      name: p.name,
      brand: p.brand,
      description: p.description,
      price: Number(p.price) || 0,
      cost: p.cost != null ? Number(p.cost) || undefined : undefined,
      imageUrl: p.imageUrl,
      taxId: p.taxId,
      selectedQuantity: Number(p.quantity) || 1,
      discount: normalizeDiscountPercent(p.discount),
      customPrice: undefined,
      customTaxId: undefined,
      selectedCoSub: orderLineCoSubFromPayload(p),
      warehouseId: lineWh || headerWh,
    };
  });
}

export type OrderEditCreditUiState = {
  creditEnabled: boolean;
  creditTermsDays: string;
  creditDueDate: string;
};

/** Derive credit UI fields from a persisted sale (no client-profile invention). */
export function creditUiStateFromOrder(
  o: Order,
  dateToInputValue: (date: Date) => string
): OrderEditCreditUiState {
  const orderCreditTerms =
    o.creditTermsDays !== undefined && o.creditTermsDays !== null
      ? Number(o.creditTermsDays)
      : null;
  const orderHasCreditTerms =
    orderCreditTerms != null &&
    Number.isFinite(orderCreditTerms) &&
    orderCreditTerms > 0;
  const orderHasZeroCreditTerms =
    orderCreditTerms != null &&
    Number.isFinite(orderCreditTerms) &&
    orderCreditTerms <= 0;
  return {
    creditEnabled:
      !orderHasZeroCreditTerms &&
      (orderHasCreditTerms || Boolean(o.dueDate)),
    creditTermsDays: orderHasCreditTerms ? String(o.creditTermsDays) : '',
    creditDueDate:
      !orderHasZeroCreditTerms && o.dueDate
        ? dateToInputValue(new Date(o.dueDate as Date | string))
        : '',
  };
}
